<div class="wrapper">
  <div class="loaded-content" style="padding-left: 15px;" [class.blurred]="showSpinner">
    <input #ordersearch type="text" [(ngModel)]="orderSearch" style="width: 200px;" placeholder="Receive Accession" />
    <button (click)="handleSearchButton()" style="margin-left: 10px; padding: 4px; width: 35px;">
      <i class="fa fa-search"></i>
    </button>

  </div>
</div>
<p-toast></p-toast>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>

<p-dialog [(visible)]="showNameConfirmDialog" modal="true" [style]="{width: '850px'}" position="top" [closable]="false" [closeOnEscape]="false">
  <ng-template #header>
    <h3>Confirm Specimen, Name and DOB </h3> Sample {{order.Accession}}
  </ng-template>
  <div class="fluid grid">
    <div class="h4 col-12 formgroup-inline">
      <div class="h4 col-12 formgroup-inline">

        <div class="col-6">
          <div class="grid">
            <div class="col-12">
              Specimen: {{getSpecimenTypeNameByCode(order?.SpecimenTypeCode)}}
            </div>
            <div class="h6 col-12" *ngIf="order.PatientSampleObserved != null && order.PatientSampleObserved != order.SpecimenTypeCode">
              Observed: {{getSpecimenTypeNameByCode(order.PatientSampleObserved)}}
            </div>
          </div>
        </div>
        <div class="col-6 formgroup-inline">
          <div class="field-radiobutton">
            <p-radioButton name="specimenMatch" styleClass="radio-style" inputId="specimenMatch1"
                           [ngClass]="{'selectedgreen':order.SpecimenTypeMatch}" [value]="true" [(ngModel)]="order.SpecimenTypeMatch" label="Matches">
            </p-radioButton>
            <label for="specimenMatch1" class="ml-2">Matches</label>
          </div>
          <div class="field-radiobutton">
            <p-radioButton name="specimenMatch" styleClass="radio-style" inputId="specimenMatch2"
                           [ngClass]="{'selectedexception':!order.SpecimenTypeMatch}" [value]="false" [(ngModel)]="order.SpecimenTypeMatch" label="Does not match">
            </p-radioButton>
            <label for="specimenMatch2" class="ml-2">Does not match</label>
          </div>
        </div>
      </div>
    </div>

    <div class="h4 col-12 formgroup-inline">
      <div class="h4 col-12 formgroup-inline">
        <div class="col-6 formgroup-inline">Name: {{order.FirstName}} {{order.LastName}}</div>
        <div class="col-6 formgroup-inline">
          <div class="field-radiobutton">
            <p-radioButton name="nameMatch" styleClass="radio-style" inputId="nameMatch1"
                           [ngClass]="{'selectedgreen':order.NameMatch}" [value]="true" [(ngModel)]="order.NameMatch" label="Matches">
            </p-radioButton>
            <label for="nameMatch1" class="ml-2">Matches</label>
          </div>
          <div class="field-radiobutton">
            <p-radioButton name="nameMatch" styleClass="radio-style" inputId="nameMatch2"
                           [ngClass]="{'selectedexception': order.NameMatch!= null && !order.NameMatch}" [value]="false" [(ngModel)]="order.NameMatch" label="Does not match">
            </p-radioButton>
            <label for="nameMatch2" class="ml-2">Does not match</label>
          </div>
        </div>
      </div>

    </div>
    <div class="h4 col-12 formgroup-inline">
      <div class="h4 col-12 formgroup-inline">
        <div class="col-6 formgroup-inline">Birth Date: {{order.BirthDate | date:'MM/dd/yyyy' }}</div>
        <div class="col-6 formgroup-inline">
          <div class="field-radiobutton">
            <p-radioButton name="birthDateMatch" styleClass="radio-style" inputId="birthDateMatch1"
                           [ngClass]="{'selectedgreen':order.BirthDateMatch}" [value]="true" [(ngModel)]="order.BirthDateMatch" label="Matches">
            </p-radioButton>
            <label for="birthDateMatch1" class="ml-2">Matches</label>
          </div>
          <div class="field-radiobutton">
            <p-radioButton name="birthDateMatch" styleClass="radio-style" inputId="birthDateMatch2"
                           [ngClass]="{'selectedexception':order.BirthDateMatch!= null && !order.BirthDateMatch}" [value]="false" [(ngModel)]="order.BirthDateMatch" label="Does not match">
            </p-radioButton>
            <label for="birthDateMatch2" class="ml-2">Does not match</label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex justify-content-center w-full">
    <p-button (onClick)="cancelNameConfirmDialog()" icon="pi pi-trash" label="Cancel" class="m-2"></p-button>
    <p-button (onClick)="closeNameConfirmDialog()" icon="pi pi-check" label="Save" class="m-2"></p-button>
  </div>
</p-dialog>
